module.exports = __webpack_public_path__ + "img/primary_6x2.ac20139d.svg";